import { render, staticRenderFns } from "./Wishes.vue?vue&type=template&id=bcb10afe&"
import script from "./Wishes.vue?vue&type=script&lang=js&"
export * from "./Wishes.vue?vue&type=script&lang=js&"
import style0 from "./Wishes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports